<template>
  <div>
    <p class="text-dark mb-0 font-weight-bold">Includes These Items:</p>
    <p v-if="savedAmount > 0" class="text-success font-italic">You save <strong>${{formatCurrency(savedAmount)}}</strong> by purchasing this bundle.</p>
    <ul class="list-group bundled-products-list">
      <li v-for="product in $page.props.product.bundled_products" :key="product.key" :class="{'cursor-pointer':product.id}" class="list-group-item pb-0 pt-2 px-3 px-0">
        <ProductRow :item="product" :itemName="product.name" :sku="product.sku" productStyle="compact" margin="0" @click="productLink(product)">
          <p v-if="product.included_description" class="m-0 text-primary text-size-small font-weight-bold">
            {{product.included_description}}
            <span class="text-success ml-2" v-if="product.productPrice.price">${{formatCurrency(product.productPrice.price)}}</span>
          </p>
          <p v-else class="m-0 text-primary text-size-small font-weight-bold">
            {{product.included_qty}} of {{product.sku}}
            <span class="text-success ml-2" v-if="product.productPrice.price">${{formatCurrency(product.productPrice.price)}}</span>
          </p>
          <p class="m-0 text-secondary text-size-small">{{product.short_description}}</p>
        </ProductRow>
      </li>
    </ul>
  </div>
</template>

<script>
  import ProductRow from '@/Components/Shop/ProductRow'

  export default {
    components: {
      ProductRow
    },
    props: {
      productRoute: String,
      isWholesale: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      savedAmount() {
        return this.$page.props.bundleTotalIndividual - this.$page.props.product.productPrice.price
      }
    },
    methods: {
      productLink(product) {
        if (product.id) this.$inertia.visit(this.route(this.productRoute, product.id))
      }
    }
  }
</script>
